import ApiBase from 'Services/Api/ApiBase';

class ServiceUserMedicationsTaken extends ApiBase {
    route = '/service-users/medications-taken';
};

export default new ServiceUserMedicationsTaken();